<xpo-footer [version]="buildVersion">
  <div class="footer__actions">
    <a xpo-regular-link color="accent" (click)="openHelpLink()" [id]="ids.help">{{ labels.help }}</a>
    <a xpo-regular-link color="accent" [href]="getMailLink()" [id]="ids.feedback">{{ labels.feedback }}</a>
    <a xpo-regular-link color="accent" (click)="openReleaseNotesLink()" [id]="ids.releaseNotes">{{ labels.releaseNotes }}</a>
  </div>
</xpo-footer>
